<!-- MAIN COMPONENT ROUTING INTERNET PORTAL -->
<router-outlet></router-outlet>

<!-- GLOBAL DECENTRALIZED NODE NOTIFICATION TOAST LAYER -->
@if (partnerService.isToastOpen()) {
  <div [class]="'toast-container animate-slideToast toast-' + partnerService.toastType()">
    <div style="display: flex; align-items: flex-start; gap: 14px; width: 100%;">
      <!-- Icon column -->
      <div style="display: flex; align-items: center; justify-content: center; margin-top: 2px;">
        @if (partnerService.toastType() === 'success') {
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        } @else if (partnerService.toastType() === 'error') {
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        } @else {
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
        }
      </div>

      <!-- Text Content column -->
      <div style="display: flex; flex-direction: column; gap: 2px; flex-grow: 1; text-align: left;">
        <span style="font-weight: 700; color: #ffffff; font-size: 1rem; font-family: var(--font-sans); letter-spacing: -0.01em;">
          @if (partnerService.toastType() === 'success') { Success }
          @else if (partnerService.toastType() === 'error') { Error }
          @else { Info }
        </span>
        <span style="font-weight: 500; color: rgba(255, 255, 255, 0.95); font-size: 0.92rem; font-family: var(--font-sans); line-height: 1.4;">
          {{ partnerService.toastMessage() }}
        </span>
      </div>

      <!-- Close Button -->
      <button class="toast-close-btn" (click)="partnerService.closeToast()" aria-label="Close notification">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  </div>
}
